export const DELETE_POOL_REQUESTS_SUCCESS = 'DELETE_POOL_REQUESTS_SUCCESS';

export const deletePoolRequestsSuccess = ({ ids }) => ({
    type: DELETE_POOL_REQUESTS_SUCCESS,
    payload: {
        ids,
    }
});
